"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoAncestorBindingConstraintsWithServiceId = isNoAncestorBindingConstraintsWithServiceId;
const isBindingConstraintsWithServiceId_1 = require("./isBindingConstraintsWithServiceId");
const isNoAncestorBindingConstraints_1 = require("./isNoAncestorBindingConstraints");
function isNoAncestorBindingConstraintsWithServiceId(serviceId) {
    return (0, isNoAncestorBindingConstraints_1.isNoAncestorBindingConstraints)((0, isBindingConstraintsWithServiceId_1.isBindingConstraintsWithServiceId)(serviceId));
}
//# sourceMappingURL=isNoAncestorBindingConstraintsWithServiceId.js.map